import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../hooks/useDateFormat";

const DatePicker = ({ calendarStartDate, calendarEndDate }) => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector((state) => state.multiLocation.selectedRequestDates);

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(
      actionCreators.updateDates({
        startDate: startDate,
        endDate: endDate
      })
    );
  };
  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      updateDates={handleUpdateDates}
    />
  );
};

export default DatePicker;
